(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["suruchi-about-page"] && !Shopify.designMode) return;
  try {
    
  // Stats number counter: 0 theke start kore original number (19+, 6, 1) porjonto count up animation
  document.addEventListener('DOMContentLoaded', () => {
    const statNumbers = document.querySelectorAll('.sap-stats__number');
    if (!statNumbers.length) return;

    const animateNumber = (el) => {
      const targetText = el.dataset.target;
      const match = targetText.match(/^(\d+)(.*)$/);
      if (!match) return;

      const targetNumber = parseInt(match[1], 10);
      const suffix = match[2] || '';
      const duration = 1500;
      const startTime = performance.now();

      const step = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const currentValue = Math.floor(progress * targetNumber);
        el.textContent = currentValue + suffix;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = targetNumber + suffix;
        }
      };

      requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateNumber(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    statNumbers.forEach((el) => {
      el.dataset.target = el.textContent.trim();
      el.textContent = '0';
      observer.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
